// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionStyle: 'style2',
		suggestionStyle2MainContainerSelector: '#shopify-section-header',
		suggestionMobileStyle: 'style2',
	}
};

//Set theme search mode to product only
window.theme.searchMode = 'product';

(function() {
	BoostPFS.inject(this);
  
    InstantSearch.prototype.beforeInit = function(id) {
      jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]').each(function(i) {
        if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
          var clone = jQ(this).clone();
          jQ(this).replaceWith(clone);
        }
      }); 

    }

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	SearchInput.prototype.beforeBindEvents = function (id) {
		var id = this.id;
		if (id == Class.searchBox + '-0') {
			this.$element = removeThemeSearchEvent();
			this.instantSearchResult.$searchInputElement = this.$element;
		}
		recallThemeOnPageShowEvent();

		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot redirect to search page when pressing enter
    jQ('.boost-pfs-search-box').on('keypress', function(event) {	
      if (event.keyCode == 13) {	
        jQ(this).parents('form').submit();	
      }	
    })
  }

	function removeThemeSearchEvent() {
		// Remove all events
		if (jQ('[name="q"]').length > 0) {
			var cloneSearchBar = jQ('[name="q"]').first().clone();
			jQ(cloneSearchBar).removeClass('Form__Input').addClass('Search__Input Heading');
			jQ('[name="q"]').first().empty().append(cloneSearchBar);
			if (jQ('#Search').length > 0) {
				if (jQ('#Search').hasClass('Modal--fullScreen')) {
					jQ('#Search').attr("style", "height: 0px !important");
				}
				jQ('#Search .Search__Results').attr("style", "display: none !important");
			}

			// Rebuild click search icon event
			if (jQ('[data-action="toggle-search"]').length > 0) {
				jQ('[data-action="toggle-search"]').on('click', function () {
					setTimeout(function () {
						jQ('[name="q"]').first().focus();
					}, 500);
				})
			}
		}
		// disable page transition
		if (window.theme && window.theme.showPageTransition) {
			window.theme.showPageTransition = false;
		}
		return jQ('[name="q"]').first();
	}

	function recallThemeOnPageShowEvent() {
		// disable page transition
		var pageTransition = document.querySelector('.PageTransition');
		if (pageTransition) {
			pageTransition.style.visibility = 'visible';
			pageTransition.style.opacity = '0';
		}
		// refresh cart
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
			bubbles: true
		}));
	}
  
  	/*-Start-Boost-127678-*/// Only show prioces for in stock variants
  	InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    	// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var data = this.data;
		
      	// Format price
      	var priceMinAvailable;
      	var priceMaxAvailable;
        var compareMinAvailable;
      
      	for (var i in data.variants) {
              var variant = data.variants[i];
              if (variant.available) {
                if  (!priceMinAvailable || priceMinAvailable > variant.price) {
                    priceMinAvailable = variant.price;
                }
                if  (!priceMaxAvailable || priceMaxAvailable < variant.price) {
                    priceMaxAvailable = variant.price;
                }
                if (variant.compare_at_price) {
                  if  (!compareMinAvailable || compareMinAvailable > variant.compare_at_price) {
                      compareMinAvailable = variant.compare_at_price;
                  } 
                }
              }
        }

        if(typeof(priceMinAvailable) !== 'undefined'){
            var onSale = compareMinAvailable > priceMinAvailable;
    		var price = Utils.formatMoney(priceMinAvailable/1);
            var compareAtPrice = '';
    		if (this.data && compareMinAvailable) {
    			compareAtPrice = Utils.formatMoney(compareMinAvailable/1);
    		}
        }else{
            var onSale = data.compare_at_price_min > data.price_min;
            var price = Utils.formatMoney(data.price_min);
            var compareAtPrice = '';
    		if (this.data && data.compare_at_price_min) {
    			compareAtPrice = Utils.formatMoney(data.compare_at_price_min);
    		}
        }
		
		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}
      
      	var priceVaries = priceMinAvailable != priceMaxAvailable; // Check a product has many prices
      	if (priceVaries) {
          	price = 'From ' + price;
        }
		return result
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
   }; 
  

  /*-Start-Boost-127678-*/

    // Start Boost 205024
    var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    var localeURLPart = "";

    if (hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSConfig.general.current_locale;
    }
  
    InstantSearchResultItemProduct.prototype.afterRender = function() {
      if (this.hasOwnProperty('data') && this.data !== null) {
        var data = this.data;
        quickUrl = localeURLPart + '/products/' + this.data.handle + '?view=boost-pfs-prod-prices';
        jQ.ajax({
            url: quickUrl,
            success: function(result) {
              var res = JSON.parse(result)
              console.log({res})
                jQ('[data-id="' + res.id + '"]').find('.boost-pfs-search-suggestion-product-price').addClass('active').html(buildPrice(res));
            }
        });
      }
    }

    function buildPrice(data) {
		var html = '';

        var onSale = data.compare_at_price_min > data.price_min;
        var firstVariant = data['variants'][0];

        for (var i = 0; i < data['variants'].length; i++) {
          if (data['variants'][i].available) {
              firstVariant = data['variants'][i];
              break;
          }
        }

        console.log({firstVariant})
        if (firstVariant.available) {
          if (onSale) {
              html += '<span class="boost-pfs-search-suggestion-product-sale-price" style="white-space: nowrap;">' + Utils.formatMoney(data.variants[0].price, Globals.moneyFormat, true) + '</span>';
              html += '<s style="white-space: nowrap;">' + Utils.formatMoney(data.variants[0].compare_at_price, Globals.moneyFormat, true) + '</s> ';
          
          } else {
            html += '<span class="boost-pfs-search-suggestion-product-regular-price" style="white-space: nowrap;">' + Utils.formatMoney(data.variants[0].price, Globals.moneyFormat, true) + '</span>';
          }
        } else {
          if (onSale) {
              html += '<span class="boost-pfs-search-suggestion-product-sale-price" style="white-space: nowrap;">' + Utils.formatMoney(data.price_min, '', true) + '</span>';
              html += '<s style="white-space: nowrap;">' + Utils.formatMoney(data.compare_at_price_min, '', true) + '</s> ';
          
          } else {
            html += '<span class="boost-pfs-search-suggestion-product-regular-price" style="white-space: nowrap;">' + Utils.formatMoney(data.price_min, '', true) + '</span>';
          }
        }
        
		
		return html;
	}
    // End Boost 205024

	  /* Start Boost BO-103877895 */
  InstantSearchResultItemProduct.prototype.customizeProductTitle = function() {
		// Override this method for customization
		return _decodeHtml(this.title);
  }
  
  function _decodeHtml(htmlString) {
	if (!htmlString) return '';
    var textarea = document.createElement('textarea');
    textarea.innerHTML = htmlString;
    return textarea.value;
  }
  /* End Boost BO-103877895 */

	InstantSearchApi.beforeCall = function(eventType, eventInfo) {
		if (Shopify && Globals) {
			Globals.instantSearchQueryParams.currency = Shopify.currency.active;
			Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
			Globals.instantSearchQueryParams.country = Shopify.country;
			Globals.instantSearchQueryParams.return_all_currency_fields = false;
		}
	}
})();